export default "__VITE_ASSET__DEAZ$qrn__"